import * as R from 'ramda';

const accountUrlFormatters = {
    instagram: id => `https://instagram.com/${id}`,
    youtube: id => `https://www.youtube.com/channel/${id}`,
    twitter: id => `https://twitter.com/${id}`
};

export function getSocialAccountUrl(platform, socialId) {
    if (!R.isNil(platform) && !R.isNil(socialId)) {
        const formatter = accountUrlFormatters[platform] || R.identity;
        return formatter(socialId);
    }
}



// WEBPACK FOOTER //
// ./common/social_helper.js